import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, AfterUseQuestionnaire } from "../stores/store_types"

const callAfterUseQuestionnairesAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, afterUseQuestionnaires:  Array<AfterUseQuestionnaire>, afterUseQuestionnairesPublished: boolean) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/after_use_questionnaires",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["afterUseQuestionnaires"], response.data["published"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callDownloadAfterUseQuestionnairesAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, blob: Blob) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/after_use_questionnaires.csv",
    {
      headers: headers,
      responseType: "blob",
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString(),
      }
    }
  ).then((response: AxiosResponse) => {
    const mineType = response.headers["content-type"]
    const blob = new Blob([response.data], { type: mineType })
    successCallback(response.headers, blob)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callAfterUseQuestionnairesBulkUpdateAPI = (headers: AuthHeaders, params: Array<{id: number, requestOrOpinion: string}>, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: () => void) => {
  axios.put(
    "/api/v1/after_use_questionnaires/bulk_update",
    {
      after_use_questionnaires: params
    },
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
export { callAfterUseQuestionnairesAPI, callDownloadAfterUseQuestionnairesAPI, callAfterUseQuestionnairesBulkUpdateAPI }
